import React from "react";



export default function Footer(props){
    return(
        <>
        
            <div className="footer">
                <p>
                    {props.footer}
                    <a style={{textDecoration: 'none'}} href="https://www.sema.ce.gov.br/">{props.sema}</a>
                    <a style={{textDecoration: 'none'}} href="https://douglas1.vercel.app/">{props.jaba}</a>
                </p>
            </div>
        
        </>
    )

}